(function () {
  var CONTENT_SELECTORS = [
    '.product-short-description.rte',
    '.tabbed-content--content.rte',
    '.collapsible__content.rte',
    '.side-panel-content--tab-panel.rte',
    '#aplus'
  ];

  function hasClass(node, className) {
    return node && node.classList && node.classList.contains(className);
  }

  function unwrapOldCards() {
    document.querySelectorAll('.kolice-card-table').forEach(function (node) {
      node.remove();
    });
    document.querySelectorAll('.kolice-card-table__source').forEach(function (table) {
      table.classList.remove('kolice-card-table__source');
      table.style.display = 'table';
    });
  }

  function wrapTable(table) {
    if (!table || table.closest('.kolice-description-scroll')) return;

    var columnCount = Array.prototype.reduce.call(table.querySelectorAll('tr'), function (max, row) {
      return Math.max(max, row.children.length);
    }, 0);
    if (columnCount > 0) {
      table.style.setProperty('--kolice-description-columns', columnCount);
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'kolice-description-scroll';
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  }

  function isGreyPixel(img) {
    var src = img && (img.getAttribute('src') || img.currentSrc || '');
    return /grey-pixel\.gif/i.test(src);
  }

  function lazyImageUrl(img) {
    if (!img) return '';
    return img.getAttribute('data-src') ||
      img.getAttribute('data-original') ||
      img.getAttribute('data-lazy-src') ||
      img.getAttribute('data-a-hires') ||
      '';
  }

  function removeImageNode(img) {
    var frame = img && img.closest('.kolice-description-image-frame');
    if (frame && frame.querySelectorAll('img').length === 1) {
      frame.remove();
      return;
    }

    var target = imageTarget(img);
    if (target && target.parentNode) target.remove();
  }

  function normalizeLazyImages(container) {
    container.querySelectorAll('img').forEach(function (img) {
      if (!isGreyPixel(img)) return;

      var realUrl = lazyImageUrl(img);
      var scope = img.closest('td, th, .kolice-description-scroll') || container;
      var hasLoadedDuplicate = realUrl && Array.prototype.some.call(scope.querySelectorAll('img'), function (other) {
        if (other === img) return false;
        return other.getAttribute('src') === realUrl || other.currentSrc === realUrl;
      });

      if (hasLoadedDuplicate) {
        removeImageNode(img);
        return;
      }

      if (realUrl) {
        img.setAttribute('src', realUrl);
        img.removeAttribute('data-src');
      }
    });
  }

  function removeStandaloneImagesAfterTables(container) {
    var tableWrappers = container.querySelectorAll('.kolice-description-scroll');
    if (!tableWrappers.length) return;

    var lastTableWrapper = tableWrappers[tableWrappers.length - 1];
    container.querySelectorAll('.kolice-description-image-frame--standalone').forEach(function (frame) {
      var position = lastTableWrapper.compareDocumentPosition(frame);
      if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
        frame.remove();
      }
    });
  }

  function wrapImageTarget(target, standalone) {
    if (!target || target.closest('.kolice-description-image-frame')) return;

    var wrapper = document.createElement('div');
    wrapper.className = standalone
      ? 'kolice-description-image-frame kolice-description-image-frame--standalone'
      : 'kolice-description-image-frame';

    target.parentNode.insertBefore(wrapper, target);
    wrapper.appendChild(target);
  }

  function imageTarget(img) {
    var parent = img.parentElement;
    if (!parent) return img;
    if (parent.tagName === 'PICTURE') return parent;
    if (parent.tagName === 'A' && parent.children.length === 1 && parent.textContent.trim() === '') return parent;
    return img;
  }

  function enhanceContainer(container) {
    if (!container) return;

    normalizeLazyImages(container);

    container.querySelectorAll('table').forEach(function (table) {
      wrapTable(table);
      table.querySelectorAll('img').forEach(function (img) {
        if (isGreyPixel(img)) return;
        wrapImageTarget(imageTarget(img), false);
      });
    });

    container.querySelectorAll('img').forEach(function (img) {
      if (img.closest('table, .kolice-description-image-frame')) return;
      if (isGreyPixel(img)) return;
      wrapImageTarget(imageTarget(img), true);
    });

    removeStandaloneImagesAfterTables(container);
  }

  function enhanceDescriptions() {
    unwrapOldCards();
    CONTENT_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(enhanceContainer);
    });
  }

  function runEnhanceDescriptions() {
    try {
      enhanceDescriptions();
    } catch (error) {
      if (window.console && console.warn) {
        console.warn('Kolice description table enhancement skipped:', error);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runEnhanceDescriptions);
  } else {
    runEnhanceDescriptions();
  }
  window.addEventListener('load', runEnhanceDescriptions);
  document.addEventListener('quick-view:open', function () {
    requestAnimationFrame(runEnhanceDescriptions);
    setTimeout(runEnhanceDescriptions, 300);
  });
  setTimeout(runEnhanceDescriptions, 1000);
  setTimeout(runEnhanceDescriptions, 2500);
})();
